import { useMemo } from "react";
import isEqual from "lodash/isEqual";

import {
  cleanupFormDataForSave,
  getNestedValue,
  mergeDefaultValues,
} from "containers/admin/clients/client/components/form-builder/form-builder";
import type { FormPageTab } from "containers/admin/clients/client/components/form-page-layout/form-page-layout";
import { getStrategyData } from "containers/admin/clients/client/programs-page/program-strategy-form.utils";

type UseTabDirtyStateOptions = {
  tabs: FormPageTab[];
  draftData: Record<string, unknown>;
  savedData: Record<string, unknown>;
  isEditing: boolean;
};

const getNormalizedTabValues = (tab: FormPageTab, data: Record<string, unknown>) =>
  cleanupFormDataForSave(
    tab.schema,
    mergeDefaultValues(tab.schema, getStrategyData(getNestedValue(data, tab.dataPath ?? [tab.id]))),
  );

export const useTabDirtyState = ({ tabs, draftData, savedData, isEditing }: UseTabDirtyStateOptions) => {
  const hasChanges = useMemo(
    () =>
      isEditing &&
      tabs.some(
        (tab) => !isEqual(getNormalizedTabValues(tab, draftData), getNormalizedTabValues(tab, savedData)),
      ),
    [tabs, draftData, savedData, isEditing],
  );

  return { hasChanges };
};
